// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"485":"d3c86120","799":"77d9d867","944":"55acf776"}[chunkId] + ".css";
};